jQuery(document).ready(function() {

});

var calculatorElements = {};
var calculatorSender = {};
window.addEventListener('message', function(a){
    try{
        var parsedData = JSON.parse(a.data);
        if(parsedData.origin === "dfg" && parsedData.action === "formSaved" && parsedData.type === "redirect"){
            var gaFilter = dataLayer.filter(function(item){
                return item.user && item.user.ga_client_id;
            });
            if(gaFilter.length > 0){
                window.sessionStorage.setItem(gaFilter[0].user.ga_client_id, calculatorSender.loanAmount + "_" + calculatorSender.term + "_" + calculatorSender.frequency);
            }
        }
    }catch(e){
        // Do nothing
    }
});


var calculatorEvents = {
    EventAction_ClientRequestedAmount: 'loan amount',
    Initialize: function(){
        calculatorEvents.Calculate(calculatorSender.frequency, calculatorSender.loanAmount, calculatorSender.term);
        jQuery('#calculator-term-dropdown').change(function() {
            calculatorChangeTerms(this.value);
        });
        jQuery('#calculator-interest-rate-input').change(function() {
            calculatorChangeTerms(this.value);
        });
    },
    Calculate: function(frequency, loanAmount, terms){

        // Loan parameters
        let requestedLoanAmount = parseInt(loanAmount);
        let originationFeeRate = 0.035;
        if (originationFee !== undefined) {
            originationFeeRate = originationFee;
        }
        let originationFeeAmount = requestedLoanAmount * originationFeeRate;
        // let adjustedPrincipalWithFee = requestedLoanAmount + originationFeeAmount; // principal amount including the origination fee
        let adjustedPrincipalNoFee = requestedLoanAmount; // principal amount excluding the origination fee

        // Annual APR as a decimal
        let aprValue = 31;
        if (apr !== undefined) {
            aprValue = apr;
        }

        let annualAPR = aprValue / 100;
        // Number of weeks in a year
        let weeksPerYear = 52;
        var instalments = calculatorGetNumberOfInstallments(terms, frequency)

        let weeklyInstalments = instalments.instalment;
        // Calculating weekly interest rate based on 31% APR
        let weeklyInterestRate = Math.pow(1 + annualAPR, 1 / weeksPerYear) - 1;
        // Calculating weekly repayment using the formula for annuity payments for 12 months term
        let r = weeklyInterestRate;
        let n = weeklyInstalments;
        let weeklyRepayment = adjustedPrincipalNoFee * (r * Math.pow( 1 + r, n )) / (Math.pow(1 + r, n) - 1); // weekly payment for 12 months
        // Calculate the total payback amount for 12 months term
        let totalPayBack = weeklyRepayment * weeklyInstalments;

        let repaymentsPlan = [adjustedPrincipalNoFee];

        numberOfYears = instalments.instalment / weeksPerYear;

        let currentBalance = adjustedPrincipalNoFee;
        let totalInterestPaid = 0;

        fullData = [{
            'weeks_remaining': Number(weeklyInstalments),
            'interest_charged': 0,
            'principal_owing': currentBalance
        }];

        var principalPaidTotal = 0;
        let principalOwedNoFee = [];

        for (var index = 1; index <= instalments.instalment; index ++) {

            let weeklyInterestPaid = currentBalance * weeklyInterestRate;
            let principalPaid = weeklyRepayment - weeklyInterestPaid;
            principalPaidTotal += principalPaid;
            currentBalance -= principalPaid;
            totalInterestPaid += weeklyInterestPaid;

            principalOwedNoFee.push(Math.max(currentBalance, 0)); // Avoid negative balance

            if (index % (numberOfYears * 2) === 0 || index === instalments.instalment ) {
                repaymentsPlan.push(Math.max(currentBalance, 0));
                fullData.push({
                    'weeks_remaining': (weeklyInstalments - index),
                    'interest_charged': totalInterestPaid,
                    'principal_owing': Math.max(currentBalance, 0)
                });
            }
        }

        initialiseGraph(repaymentsPlan, fullData);

        if (instalments !== null) {
            document.getElementById("instalmentAmount").innerText = '$' + (+weeklyRepayment).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        }

        document.querySelector('.repayment-breakdown__weekly-repayment').innerText = '$' + (weeklyRepayment).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });

        document.querySelector('.repayment-breakdown__payback-amount').innerText = '$' + (totalPayBack).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
        document.querySelector('.repayment-breakdown__loan-term').innerText = (terms / 52).toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 1
        }) + ' year';

        if( (terms / 52) >= 2 ) {
            document.querySelector('.repayment-breakdown__loan-term').innerText = document.querySelector('.repayment-breakdown__loan-term').innerText + 's';
        }


        document.querySelector('.repayment-breakdown__number-of-repayments').innerText = weeklyInstalments;

        if (adjustedPrincipalNoFee >= Number(150000) || instalments.term === '60') {
            document.querySelector('.security-notice--maybe-required').classList.remove('d-none');
            document.querySelector('.security-notice--not-required').classList.add('d-none');
        } else {
            document.querySelector('.security-notice--maybe-required').classList.add('d-none');
            document.querySelector('.security-notice--not-required').classList.remove('d-none');
        }

    },
    OnRangeChange: function(loanAmount){
        calculatorElements.loanDisplay.value = '$' + (+loanAmount).toLocaleString();
        document.getElementById("calculator-sender.loanAmount").value = loanAmount;
        calculatorEvents.Calculate(calculatorSender.frequency, loanAmount, calculatorSender.term);
    },
    LoanAmountValidation: function(){
        var isValid = true;
        if (calculatorSender.loanAmount){
            var loanAmount = parseInt(calculatorSender.loanAmount);
            var numberOfYears = parseInt(calculatorSender.term) / 52;
            if(numberOfYears <= 3 && (loanAmount < minLoanAmount || loanAmount > maxLoanAmount) || (numberOfYears > 3 && (loanAmount < 150000 || loanAmount > maxLoanAmount))) {
                calculatorSender.loanAmount = 0;
                isValid = false;
            }
        } else{
            calculatorSender.loanAmount = 0;
            isValid = false;
        }
        calculatorEvents.ShowHideErrorMessage(isValid, numberOfYears);
    },
    OnTermsChange: function(terms){
        document.getElementById("calculator-term-dropdown").value = terms;
        calculatorEvents.Calculate(calculatorSender.frequency, calculatorSender.loanAmount, calculatorSender.term);
    },
    ShowHideErrorMessage: function(isValid, numberOfYears){

        if (!isValid) {
            calculatorElements.loanDisplay.classList.add("invalid-amount");

            if (parseInt(numberOfYears) <= 3) {
                calculatorElements.loanError.classList.remove("invalid-feedback");
                calculatorElements.loanError150K.classList.add("invalid-feedback-150K");
            } else {
                calculatorElements.loanError.classList.add("invalid-feedback");
                calculatorElements.loanError150K.classList.remove("invalid-feedback-150K");
            }

            // Hide results, breakdown and button if invalid
            hideBreakdownOnError();

        } else {
            calculatorElements.loanDisplay.classList.remove("invalid-amount");
            calculatorElements.loanError.classList.add("invalid-feedback");
            calculatorElements.loanError150K.classList.add("invalid-feedback-150K");
        }
    }
};
document.addEventListener("DOMContentLoaded", function(){

    var calculatorLoanComponent = document.querySelector(".calculator-form--sbl.prad--form");

    if  (calculatorLoanComponent) {

        var loanDisplay = document.getElementById("calculator-loan-display");
        var loanError = document.getElementById("calculator-loan-error");
        var loanError150K = document.getElementById("calculator-loan-error-150K");
        var termDropdown = document.getElementById("calculator-term-dropdown");
        var calculateButton = document.getElementById("calculator-calculate-button");

        calculatorElements = {
            loanDisplay: loanDisplay,
            loanError: loanError,
            loanError150K: loanError150K,
            termDropdown: termDropdown
        };
        calculatorSender = {
            loanAmount: document.getElementById("calculator-sender.loanAmount").value,
            term: document.getElementById("calculator-term-dropdown").value,
            frequency: document.getElementById("calculator-sender.frequency").value
        };

        loanDisplay.onkeydown = function(e){
            var validKeyCode = [8, 13, 37, 38, 39, 40, 46];
            if((isNaN(e.key) && validKeyCode.indexOf(e.keyCode) === -1)){
                e.preventDefault(e);
            }
            else if(loanDisplay.value.length === 8 && validKeyCode.indexOf(e.keyCode) === -1) {
                e.preventDefault(e);
            }
        };

        loanDisplay.onkeyup = function(e){
            calculatorSender.loanAmount = this.value.replace(/\D/g,'');
            document.getElementById("calculator-sender.loanAmount").value = calculatorSender.loanAmount;
            calculatorFormatCurrency(this);
            calculatorEvents.LoanAmountValidation();
            var learnMore = document.querySelector(".cta-button-container .cta-button.cta-button--learn-more");
            if (learnMore) {
                learnMore.setAttribute('data-amount', calculatorSender.loanAmount);
                regenerateLearnMoreLink();
            }
        };

        loanDisplay.onchange = function(){
            calculatorSender.loanAmount = this.value.replace(/\D/g,'');
            calculatorFormatCurrency(this, "blur");
            calculatorEvents.LoanAmountValidation();
            document.getElementById("calculator-sender.loanAmount").value = calculatorSender.loanAmount;
            if (loanDisplay.value === "" || loanDisplay.value === "$") {
                loanDisplay.value = "$0";
            }
        };

        termDropdown.onchange = function(){
            calculatorSender.term = parseInt(this.value);
            calculatorSender.loanAmount = document.getElementById("calculator-loan-display").value.replace(/\D/g,'');
            calculatorEvents.LoanAmountValidation();
            var learnMore = document.querySelector(".cta-button-container .cta-button.cta-button--learn-more");
            if (learnMore) {
                learnMore.setAttribute('data-term', calculatorSender.term);
                regenerateLearnMoreLink();
            }
        };

        calculateButton.onclick = function(){

            jQuery('#calculator-loan-display').trigger('change');
            jQuery('#calculator-term-dropdown').trigger('change');

            calculatorEvents.Initialize();
            document.querySelector('.result-bar').classList.remove('d-none');
            document.querySelector('.repayment-breakdown-link-container').classList.remove('d-none');
            document.querySelector('.cta-button-container').classList.remove('d-none');

            var loanError = document.getElementById('calculator-loan-error');
            var loanError150K = document.getElementById('calculator-loan-error-150K');

            // Hide results, breakdown and button if validation error
            if( !loanError.classList.contains('invalid-feedback') || !loanError150K.classList.contains('invalid-feedback-150K') ) {
                hideBreakdownOnError();
            } else {
                calculatorEvents.Initialize();
                document.querySelector('.result-bar').classList.remove('d-none');
                document.querySelector('.repayment-breakdown-link-container').classList.remove('d-none');
                document.querySelector('.cta-button-container').classList.remove('d-none');

                // Toggle link class and text
                if(document.getElementById("repayment-breakdown-link").innerHTML === "See repayment breakdown") {
                    document.querySelector('.cta-button-container').classList.remove('d-none');
                    document.querySelector('.cta-button-container--inline').classList.add('d-none');
                } else {
                    document.querySelector('.cta-button-container').classList.add('d-none');
                    document.querySelector('.cta-button-container--inline').classList.remove('d-none');
                }
                calculatorEvents.Calculate(calculatorSender.frequency, calculatorSender.loanAmount, calculatorSender.term);
            }

        };

        calculatorEvents.Initialize();

    }

    function regenerateLearnMoreLink()
    {
        var learnMore = document.querySelector(".cta-button-container .cta-button.cta-button--learn-more");
        var heroButton = document.querySelector(".cta-button.cta-button--calculator-hero.mode--sbl");
        var originalURL = learnMore.getAttribute('data-url');
        var originalHeroURL = heroButton.getAttribute('data-url');
        var newAmount = learnMore.getAttribute('data-amount');
        var newTerm = parseInt( learnMore.getAttribute('data-term') ) / 52;
        learnMore.href= originalURL + '?amount=' + newAmount + '&' + 'term=' + newTerm + '#sbl';
        if(heroButton) {
            var tNCHash = heroButton.getAttribute('data-hash') ? heroButton.getAttribute('data-hash') : '';
            heroButton.href= originalHeroURL + '?amount=' + newAmount + '&' + 'term=' + newTerm + tNCHash;
        }

    }

});
function hideBreakdownOnError() {
    document.querySelector('.result-bar').classList.add('d-none');
    document.querySelector('.repayment-breakdown-link-container').classList.add('d-none');
    if(document.getElementById("repayment-breakdown-link").innerHTML === "Hide repayment breakdown") {
        document.getElementById('repayment-breakdown-link').click();
    }
    document.querySelector('.cta-button-container').classList.add('d-none');
}

function calculatorChangeTerms(value){
    calculatorSender.term = value;
}
function calculatorGetNumberOfInstallments(terms, frequency){
    var lookup = calculatorFilterArrayByKey(instalmentsLookup, "frequency", frequency);
    return calculatorFindObjectByKey(lookup, "instalment", terms);
}
function calculatorFilterArrayByKey(array, key, value){
    var result = [];

    for(var i = 0; i< array.length; i++){
        if(array[i][key].toLocaleString() === value.toLocaleString()){
            result.push(array[i]);
        }
    }
    return result;
}
function calculatorFindObjectByKey(array, key, value){
    for(var i = 0; i< array.length; i++){
        if(array[i][key].toLocaleString() === value.toLocaleString()){
            return array[i];
        }
    }
    return null;
}

function calculatorFormatCurrency(input, blur){
    var input_value = input.value;
    // Do not validate if empty
    if(input_value === ""){
        return;
    }
    var original_len = input_value.length;
    var caret_pos = input.selectionStart;
    // check for decimal place
    var decimal_pos = input_value.indexOf(".");
    if(decimal_pos >= 0){
        var left_side = input_value.substring(0, decimal_pos);
        var right_side = input_value.substring(decimal_pos);

        left_side = calculatorFormatNumber(left_side);
        right_side = calculatorFormatNumber(right_side);
        if (blur === "blur") {
            right_side += "00";
        }
        // Limit decimal to only 2 digits
        right_side = right_side.substring(0, 2);
        // join number by .
        input_val = "$" + left_side + "." + right_side;
    } else {
        input_value = calculatorFormatNumber(input_value);
        input_value = "$" + input_value;
    }
    if(input_value.length > 2 && input_value[1] === "0"){
        input_value = input_value.replace("0", "");
    }
    input.value = input_value;
    // put caret back in the right position
    var updated_len = input_value.length;
    caret_pos = updated_len - original_len + caret_pos;
    input.selectionStart = caret_pos;
    input.selectionEnd = caret_pos;
    //input[0].setSelectionRange(caret_pos, caret_pos);
}
function calculatorFormatNumber(n) {
    // format number 1000000 to 1,234,567
    return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}